module.exports = __webpack_public_path__ + "static/media/alicante-15.a567fec9.jpg";